import { LitElement, html } from 'lit';
import './icon';

const renderIcons = (iconOn, iconOff) => html`
	<div class="toggle-switch__icons">
		<x-icon
			icon="${iconOn}"
			size="s"
			class="toggle-switch__icon"
		></x-icon>
		<x-icon
			icon="${iconOff}"
			size="s"
			class="toggle-switch__icon"
		></x-icon>
	</div>
`;

class Toggle extends LitElement {
	static get properties() {
		return {
			id: { type: String },
			iconOn: { type: String },
			iconOff: { type: String },
			name: { type: String },
			value: { type: String },
			isChecked: { type: Boolean },
			isDisabled: { type: Boolean },
		};
	}

	constructor() {
		super();

		this.id = '';
		this.name = '';
		this.value = '';

		this.iconOn = '';
		this.iconOff = '';

		this.isChecked = false;
		this.isDisabled = false;
	}

	render() {
		const hasIcon = this.iconOn !== '' || this.iconOff !== '';

		// mind the `.checked` attribute instead of `?checked`
		// https://open-wc.org/guides/knowledge/attributes-and-properties/#special-cases
		return html`
			<div class="toggle-switch">
				<input
					class="toggle-switch__input js-control"
					name="${this.name}"
					id="toggle-${this.id}"
					type="checkbox"
					value="${this.value}"
					.checked="${this.isChecked}"
					?disabled="${this.isDisabled}"
				/>
				<label
					class="toggle-switch__label"
					for="toggle-${this.id}"
				>
					${html`${hasIcon ? renderIcons(this.iconOn, this.iconOff) : ''}`}
				</label>
			</div>
		`;
	}

	createRenderRoot() {
		return this;
	}
}

customElements.define('x-toggle', Toggle);

export default Toggle;

